<!-- PAGE TITLE================================================== -->

<!-- <section class="bg-light-red page-title-section top-position1 bg-img cover-background left-overlay-secondary">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="text-center">
                    <div class="position-relative">
                        <h1> Beauty I.V. Therapy</h1>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section> -->

<!-- BANNER
        ================================================== -->
<section class="bg-banner pt-0 pb-0 banner-style03">
    <div class="hero-slider-wrapper">
        <img src="/assets/images/banner/banner1.jpeg" class="desktop-show" alt="Red Monk Wellness" />
        <img src="/assets/images/banner/banner1m.jpeg" class="mobile-show" alt="Red Monk Wellness" />
    </div>
</section>






<div class="beauty-section">
    <!-- Cosmetic IV Collection start -->

    <div class="container mb-5">
        <div class="iv-section-header">
            <p class="lead text-danger"> Beauty I.V. Therapy</p>
            <h2 class="section-title">The Cosmetic IV Collection</h2>
            <!-- <p class="lead text-danger">Anti-Ageing Wellness IV’s</p> -->
            <p class="mt-3">With the powerful backing of advanced formulations and an expert fraternity of experienced
                medical experts, Red Monk Wellness has brought to the table a carefully curated line of premium cosmetic
                drips designed to bolster health, beauty and performance from deep within.</p>
        </div>


        <!-- <div class="row g-4">
            <div class="col-lg-4 col-md-6" data-aos="fade-up">
                <div class="hoh-service-card">
                    <div class="hoh-card-image"
                        style="background-image: url('/assets/images/timelessmonk/Eternal-Monk-IV.png');">
                    </div>
                    <div class="text-center">
                        <h4 class="text-teal">Eternal Monk IV (Anti-Ageing; Longevity)</h4>
                        <p class="mt-3 text-dark">Eternal Monk is a revitalizing blend that supports collagen
                            production- designed to slow down visible signs of aging, it helps skin stay firm, radiant
                            and youthful, all the while energizing your body at the deepest level.</p>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="100">
                <div class="hoh-service-card">
                    <div class="hoh-card-image"
                        style="background-image: url('/assets/images/timelessmonk/Iron-Monk-IV-Limitless-Monk-IV.png');">
                    </div>
                    <div class="text-center">
                        <h4 class="text-teal">Iron Monk IV / Limitless Monk IV (Energy, Performance; Recovery)</h4>
                        <p class="mt-1 text-dark">For those who refuse to slow down. Iron Monk fuels strength and
                            stamina, while it is also built for sharper focus and all-day vitality.</p>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="200">
                <div class="hoh-service-card">
                    <div class="hoh-card-image"
                        style="background-image: url('/assets/images/timelessmonk/Monks-Guard-IV.png');">
                    </div>
                    <div class="text-center">
                        <h4 class="text-teal">Monk’s Guard IV (Immunity; Protection)</h4>
                        <p class="mt-1 text-dark">In an environment riddled with stress, pollution and climate changes,
                            the body’s defence needs constant care. Monk’s Guard strengthens resilience, while building
                            calm protection with immunity-boosting nutrients.</p>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6" data-aos="fade-up">
                <div class="hoh-service-card">
                    <div class="hoh-card-image"
                        style="background-image: url('/assets/images/timelessmonk/Aqua-Monk-IV.png');">
                    </div>
                    <div class="text-center">
                        <h4 class="text-teal">Aqua Monk IV (Hydration, Hangover ; Reset)</h4>
                        <p class="mt-1 text-dark">Whether it’s post-travel fatigue, a late night out, or simply
                            dehydration, this is your instant reset button. Aqua Monk IV rapidly restores fluid balance,
                            replenishes electrolytes and flushes out toxins.</p>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="100">
                <div class="hoh-service-card">
                    <div class="hoh-card-image"
                        style="background-image: url('/assets/images/timelessmonk/Golden-Monk-IV.png');">
                    </div>
                    <div class="text-center">
                        <h4 class="text-teal">Golden Monk IV (Skin, Glow; Beauty)</h4>
                        <p class="mt-1 text-dark">The Golden Monk IV is crafted to brighten skin tone, reduce dullness
                            and give a luminous glow from within. Powered with antioxidants and skin-repairing
                            nutrients, it supports collagen synthesis and detoxifies your system</p>
                    </div>
                </div>
            </div>
        </div> -->

        <div class="row g-4">
            <div class="col-12 text-center text-muted" *ngIf="loadingItems">Loading...</div>

            <div class="col-lg-4 col-md-6" *ngFor="let p of beautyItems; trackBy: trackByItemId">
                <div class="hoh-service-card">
                    <div class="beauty-iv-shape">
                        <img *ngIf="p.Image && !failedImages.has('p' + p.TreatmentItemID); else ivAlt"
                            [src]="imgUrl(p.Image)" [alt]="p.TreatmentName" loading="lazy"
                            (error)="onImgError('p' + p.TreatmentItemID)">
                        <ng-template #ivAlt>
                            <span class="pkg-alt">{{ p.TreatmentName }}</span>
                        </ng-template>
                    </div>
                    <div class="text-center">
                        <h4 class="text-teal">{{ p.TreatmentName }}</h4>
                        <h6 class="text-dark" *ngIf="p.Benefits">{{ p.Benefits }}</h6>
                        <p class="mt-1 text-dark">{{ p.Description }}</p>
                    </div>
                </div>
            </div>

            <div class="col-12 text-center text-muted" *ngIf="!loadingItems && beautyItems.length === 0">
                No treatments available.
            </div>
        </div>

    </div>
</div>

<!-- Fauziya Dinamic Treatments  -->
<!-- Loading state -->
<section class="section-padding bg-blue-light" *ngIf="loading">
    <div class="container">
        <div class="text-center">
            <p class="lead text-danger">Beauty Treatments</p>
            <h2 class="section-title"><span>Loading...</span></h2>
        </div>
    </div>
</section>

<!-- Error state -->
<section class="section-padding bg-blue-light" *ngIf="!loading && errorMessage">
    <div class="container">
        <div class="text-center">
            <p class="lead text-danger">Beauty Treatments</p>
            <h2 class="section-title"><span>{{ errorMessage }}</span></h2>
        </div>
    </div>
</section>

<!-- Dynamic category sections -->
<section class="section-padding" [ngClass]="i % 2 === 0 ? 'bg-blue-light' : 'bg-beige-light'"
    *ngFor="let group of categoryGroups; let i = index">
    <div class="container">
        <div class="text-center">
            <p class="lead text-danger" *ngIf="i === 0">Beauty Treatments</p>
            <h2 class="section-title"><span>{{ group.category }}</span></h2>
        </div>

        <!-- More than 3 treatments: use swiper with arrows -->
        <div class="swiper-wrapper-custom" *ngIf="group.treatments.length > 3">
            <button class="custom-prev custom-prev-{{ i }}">
                <i class="fa fa-chevron-left"></i>
            </button>
            <swiper-container #swiper init="false" [attr.data-loop]="group.loop" [attr.data-index]="i">
                <swiper-slide *ngFor="let treatment of group.treatments; trackBy: trackById">
                    <div class="treatment-card2">
                        <div class="card-glow"></div>
                        <div class="treatment-content">
                            <div class="treatment-icon">
                                <!-- <img [src]="imageBaseUrl + treatment.Image" [alt]="treatment.Title"
                                    (error)="setDefaultImage($event)"> -->
                                <img *ngIf="treatment.Image && !failedImages.has('t' + i + treatment.TreatmentName); else trAlt"
                                    [src]="imageBaseUrl + treatment.Image" [alt]="treatment.TreatmentName"
                                    (error)="onImgError('t' + i + treatment.TreatmentName)">
                                <ng-template #trAlt>
                                    <span class="pkg-alt">{{ treatment.TreatmentName }}</span>
                                </ng-template>
                            </div>
                            <div class="treatment-info">
                                <h4 class="treatment-title">{{ treatment.TreatmentName }}</h4>
                                <p class="treatment-text">
                                    <span class="advantages">Advantages - </span>{{ treatment.Advantages }}
                                </p>
                            </div>
                        </div>
                    </div>
                </swiper-slide>
            </swiper-container>

            <button class="custom-next custom-next-{{ i }}">
                <i class="fa fa-chevron-right"></i>
            </button>
        </div>

        <!-- 3 or fewer treatments: plain centered cards, no swiper, no arrows -->
        <div class="static-treatments-wrapper" *ngIf="group.treatments.length <= 3">
            <div class="treatment-card2" *ngFor="let treatment of group.treatments; trackBy: trackById">
                <div class="card-glow"></div>
                <div class="treatment-content">
                    <div class="treatment-icon">
                        <!-- <img [src]="imageBaseUrl + treatment.Image" [alt]="treatment.Title"
                            (error)="setDefaultImage($event)"> -->
                        <img *ngIf="treatment.Image && !failedImages.has('t' + i + treatment.TreatmentName); else trAlt"
                            [src]="imageBaseUrl + treatment.Image" [alt]="treatment.TreatmentName"
                            (error)="onImgError('t' + i + treatment.TreatmentName)">
                        <ng-template #trAlt>
                            <span class="pkg-alt">{{ treatment.TreatmentName }}</span>
                        </ng-template>
                    </div>
                    <div class="treatment-info">
                        <h4 class="treatment-title">{{ treatment.TreatmentName }}</h4>
                        <p class="treatment-text">
                            <span class="advantages">Advantages - </span>{{ treatment.Advantages }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>


<!---About us start---->
<!-- <section class="space-extra-top space-bottom bg-blue"> 
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-5 col-xl-5 mb-40 mb-lg-0 wow fadeInUp" data-wow-delay="0.2s">
                <div class="img-box1 mega-hover">
                    <img src="/assets/images/timelessmonk/aboutus.jpg" alt="about">
                </div>
            </div>
            <div class="col-lg-7 col-xl-7 align-self-center wow fadeInUp" data-wow-delay="0.3s">
                <div class="title-area">
                    <span class="sec-subtitle"> Beauty I.V. Therapy</span>
                    <h2 class="sec-title">Setting new benchmarks in cosmetic therapy</h2>
                </div>

                <p class="about-text">Beyond the realm of wellness, the House of Hydration has also ventured into
                    the world of cosmetic I.V. therapy, where beauty and science come together in perfect harmony. In
                    other words, skincare and self-care intertwine at the cellular level, where results are far more
                    in-depth than what over-the-counter creams and supplements can ever offer.</p>

                <p class="about-text">With the robust backing of advanced formulations and an expert fraternity of
                    experienced medical experts, House of Hydration has brought to the table a carefully curated
                    line of premium cosmetic drips designed to bolster health, beauty and performance from deep
                    within. Each drip is more than just mere therapy - it’s actually an experience specially crafted
                    for those who believe in investing in themselves.</p>
            </div>
        </div>
    </div>
</section> -->

<section class="space-extra-top space-bottom bg-blue" *ngIf="content['ABOUT'] as about">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-5 col-xl-5 mb-40 mb-lg-0 wow fadeInUp" data-wow-delay="0.2s">
                <div class="img-box1 mega-hover">
                    <img [src]="contentImg(about.Image)" [alt]="about.Title">
                </div>
            </div>
            <div class="col-lg-7 col-xl-7 align-self-center wow fadeInUp" data-wow-delay="0.3s">
                <div class="title-area">
                    <span class="sec-subtitle">{{ about.Eyebrow }}</span>
                    <h2 class="sec-title">{{ about.Title }}</h2>
                </div>
                <p class="about-text" *ngFor="let p of paragraphs(about.Description)">{{ p }}</p>
            </div>
        </div>
    </div>
</section>

<!---About us end---->


<!---The Cellular Advantage start-->

<!-- <section class="corporate-section bg-blue-light">
    <div class="container">
        <div class="row align-items-center g-5">
            <div class="col-lg-7">
                <div class="brand-badge mb-4">
                    <i class="fas fa-shield-alt"></i>MEDICAL EXCELLENCE
                </div>
                <h2 class="section-header">
                    The Cellular Advantage
                </h2>
                <div class="content-card">
                    <h5>Unlocking Peak Wellness with Medically Supervised IV Therapy</h5>
                    <p class="text-muted mb-0">
                        In the relentless pursuit of optimal health, waiting for the digestive system to process
                        nutrients can feel like a bottleneck. Intravenous (IV) therapy, a method once confined to
                        hospital wards, has emerged as a premier tool in proactive wellness, offering a decisive
                        advantage: direct-to-bloodstream delivery. When administered by a qualified doctor, this therapy
                        transcends trendy "drip bar" offerings to become a precise, safe, and highly effective modality
                        for enhancing general well-being.
                    </p>
                </div>
                <div class="content-card">
                    <p class="text-muted mb-0">
                        The core principle behind IV therapy's effectiveness is 100% bioavailability. Unlike oral
                        supplements, which are subject to the unpredictable nature of the gastrointestinal tract, IV
                        infusions deliver vitamins, minerals, antioxidants, and amino acids directly to your cells. This
                        immediate and complete absorption is particularly crucial for individuals with digestive
                        inefficiencies, high-stress lifestyles, or those recovering from illness, where the body's
                        demand for nutrients is significantly heightened.
                    </p>
                </div>
                <div class="content-card">
                    <p class="text-muted mb-0">
                        Under medical supervision, IV therapy is not a one-size-fits-all solution but a personalized
                        prescription for your body's unique needs. Following a thorough health assessment, a physician
                        can formulate a custom "cocktail" to address specific wellness goals.
                    </p>
                </div>
            </div>
            <div class="col-lg-5">
                <div class="image-container">
                    <img src="/assets/images/timelessmonk/advantage.jpg" alt="The Cellular Advantage" class="img-fluid">
                </div>
            </div>

        </div>
    </div>
</section> -->


<!-- ============ C. CELLULAR ADVANTAGE (replace whole section) ============ -->
<section class="corporate-section bg-blue-light" *ngIf="content['CELLULAR_ADVANTAGE'] as adv">
    <div class="container">
        <div class="row align-items-center g-5">
            <div class="col-lg-7">
                <div class="brand-badge mb-4">
                    <i class="fas fa-shield-alt"></i>
                    MEDICAL EXCELLENCE
                </div>
                <h2 class="section-header">{{ adv.Title }}</h2>

                <div class="content-card" *ngFor="let p of paragraphs(adv.Description); let i = index">
                    <h5 *ngIf="i === 0 && adv.SubTitle">{{ adv.SubTitle }}</h5>
                    <p class="text-muted mb-0">{{ p }}</p>
                </div>
            </div>
            <div class="col-lg-5">
                <div class="image-container">
                    <img [src]="contentImg(adv.Image)" [alt]="adv.Title" class="img-fluid">
                </div>
            </div>
        </div>
    </div>
</section>
<!---The Cellular Advantage end-->

<!---Types of Therapy start-->

<!-- <section class="benefits-section bg-blue">
    <div class="container">
        <h2 class="section-title">
            IV Therapy <span class="accent">Benefits</span>
        </h2>
        <div class="row g-4">
            <div class="col-lg-3 col-md-6">
                <div class="benefit-card text-center">
                    <svg class="svg-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="4" y="4" width="16" height="16" rx="4" stroke="#ee2125" stroke-width="1.8" />
                        <path d="M9 12L11 14L15 9" stroke="#ee2125" stroke-width="1.8" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>
                    <h3 class="benefit-title">For Boosting Immunity</h3>
                    <p class="benefit-text">
                        A potent blend of high-dose Vitamin C, Zinc, and B Vitamins can fortify the body’s natural
                        defences, potentially reducing the frequency and severity of common illnesses.
                    </p>
                </div>
            </div>
            <div class="col-lg-3 col-md-6">
                <div class="benefit-card text-center">
                    <svg class="svg-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13 2L3 14H11L11 22L21 10H13L13 2Z" fill="#ee2125" fill-opacity="0.1" stroke="#ee2125"
                            stroke-width="1.6" />
                    </svg>
                    <h3 class="benefit-title">Combating Fatigue</h3>
                    <p class="benefit-text">
                        An infusion rich in B-complex vitamins, Magnesium, and amino acids can supercharge cellular
                        energy production, offering a revitalizing boost that far surpasses caffeine or sugary drinks.
                    </p>
                </div>
            </div>
            <div class="col-lg-3 col-md-6">
                <div class="benefit-card text-center">
                    <svg class="svg-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14.5 4.5L18 8L14.5 11.5" stroke="#ee2125" stroke-width="1.8" stroke-linecap="round"
                            stroke-linejoin="round" />
                        <path d="M18 8H6C4.34315 8 3 9.34315 3 11V18C3 19.6569 4.34315 21 6 21H18" stroke="#ee2125"
                            stroke-width="1.8" stroke-linecap="round" />
                    </svg>
                    <h3 class="benefit-title">Enhanced Recovery</h3>
                    <p class="benefit-text">
                        Athletes and active individuals benefit from IV drips that replenish electrolytes and deliver
                        anti-inflammatory agents, such as glutathione, accelerating muscle repair and reducing downtime.
                    </p>
                </div>
            </div>
            <div class="col-lg-3 col-md-6">
                <div class="benefit-card text-center">
                    <svg class="svg-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="12" cy="12" r="8" stroke="#ee2125" stroke-width="1.8" />
                        <path d="M12 8V16M8 12H16" stroke="#ee2125" stroke-width="1.8" stroke-linecap="round" />
                    </svg>
                    <h3 class="benefit-title">Radiant Skin & Anti-Ageing</h3>
                    <p class="benefit-text">
                        Antioxidants are delivered intravenously to combat oxidative stress—a key driver of ageing—while
                        ingredients like Biotin and Vitamin C support collagen production, promoting healthy, glowing
                        skin from within.
                    </p>
                </div>
            </div>
        </div>
        <div class="safety-note mx-auto">
            <p class="mb-0 text-center">
                The involvement of a qualified doctor is non-negotiable for ensuring both safety and efficacy. A medical
                professional can accurately identify deficiencies, rule out contraindications (such as kidney or heart
                conditions), and ensure that the procedure is performed in a sterile environment to eliminate risks of
                infection or complications.
                <strong>This level of care elevates IV therapy from a fleeting trend to a legitimate and powerful
                    component of a comprehensive wellness strategy.</strong>
            </p>
        </div>
    </div>
</section> -->

<section class="benefits-section bg-blue" *ngIf="content['BENEFITS'] as ben">
    <div class="container">
        <h2 class="section-title">
            {{ splitLast(ben.Title).main }} <span class="accent">{{ splitLast(ben.Title).accent }}</span>
        </h2>

        <div class="row g-4">
            <div class="col-lg-3 col-md-6" *ngFor="let b of benefits">
                <div class="benefit-card text-center">

                    <ng-container [ngSwitch]="b.IconKey">
                        <svg *ngSwitchCase="'shield-check'" class="svg-icon" viewBox="0 0 24 24" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <rect x="4" y="4" width="16" height="16" rx="4" stroke="#ee2125" stroke-width="1.8" />
                            <path d="M9 12L11 14L15 9" stroke="#ee2125" stroke-width="1.8" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                        <svg *ngSwitchCase="'bolt'" class="svg-icon" viewBox="0 0 24 24" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path d="M13 2L3 14H11L11 22L21 10H13L13 2Z" fill="#ee2125" fill-opacity="0.1"
                                stroke="#ee2125" stroke-width="1.6" />
                        </svg>
                        <svg *ngSwitchCase="'recovery'" class="svg-icon" viewBox="0 0 24 24" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path d="M14.5 4.5L18 8L14.5 11.5" stroke="#ee2125" stroke-width="1.8"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M18 8H6C4.34315 8 3 9.34315 3 11V18C3 19.6569 4.34315 21 6 21H18" stroke="#ee2125"
                                stroke-width="1.8" stroke-linecap="round" />
                        </svg>
                        <svg *ngSwitchCase="'plus-circle'" class="svg-icon" viewBox="0 0 24 24" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <circle cx="12" cy="12" r="8" stroke="#ee2125" stroke-width="1.8" />
                            <path d="M12 8V16M8 12H16" stroke="#ee2125" stroke-width="1.8" stroke-linecap="round" />
                        </svg>
                        <!-- any other icon = Font Awesome class stored in DB, e.g. "fas fa-heart" -->
                        <i *ngSwitchDefault class="benefit-fa-icon" [ngClass]="b.IconKey"></i>
                    </ng-container>

                    <h3 class="benefit-title">{{ b.Title }}</h3>
                    <p class="benefit-text">{{ b.Description }}</p>
                </div>
            </div>
        </div>

        <!-- Safety note: 1st paragraph normal, 2nd paragraph bold -->
        <div class="safety-note mx-auto" *ngIf="paragraphs(ben.Description) as sp">
            <p class="mb-0 text-center">
                {{ sp[0] }}
                <strong *ngIf="sp[1]">{{ sp[1] }}</strong>
            </p>
        </div>
    </div>
</section>
<!---Types of Therapy end-->



<!-- 4 How Does IV Therapy Help -->

<!-- <section class="section bg-blue-light">
    <div class="container">
        <div class="row align-items-center g-5">
            <div class="col-lg-5" data-aos="fade-right">
                <img src="/assets/images/timelessmonk/iv-therapy.jpg" alt="IV Therapy" class="benefit-image img-fluid">
            </div>
            <div class="col-lg-7" data-aos="fade-left">
                <div class="title-area">
                    <span class="subtitle1">IV Wellness Therapy</span>
                </div>
                <h2 class="section-title mb-2 text-start">Hype vs. Health — What You Need to Know</h2>
                <p class="text-dark">Intravenous (IV) therapy for general wellness is gaining immense popularity. But
                    is it a valid health practice or just an expensive trend? We break down the facts about its
                    effectiveness, predominantly when guided by a medical professional.</p>
            </div>
        </div>
    </div>
</section> -->

<!-- ============ E. HYPE VS HEALTH (replace whole section) ============ -->
<section class="section bg-blue-light" *ngIf="content['HYPE_VS_HEALTH'] as hype">
    <div class="container">
        <div class="row align-items-center g-5">
            <div class="col-lg-5" data-aos="fade-right">
                <img [src]="contentImg(hype.Image)" [alt]="hype.Title" class="benefit-image img-fluid">
            </div>
            <div class="col-lg-7" data-aos="fade-left">
                <div class="title-area">
                    <span class="subtitle1">{{ hype.Eyebrow }}</span>
                </div>
                <h2 class="section-title mb-2 text-start">{{ hype.Title }}</h2>
                <p class="text-dark" *ngFor="let p of paragraphs(hype.Description)">{{ p }}</p>
            </div>
        </div>
    </div>
</section>
<!-- ===== F. timelessmonk.html: REPLACE the whole custom section block (F) with this ===== -->
<section class="space-extra-top space-bottom bg-blue" *ngFor="let s of customSections">
    <div class="container">
        <div class="row align-items-center g-5" [class.flex-row-reverse]="s.ImagePosition === 'Right'">
            <div class="col-lg-5" *ngIf="s.Image">
                <img [src]="contentImg(s.Image)" [alt]="s.Title" class="custom-section-img"
                    [class.img-right]="s.ImagePosition === 'Right'">
            </div>
            <div [ngClass]="s.Image ? 'col-lg-7' : 'col-12'">
                <div class="title-area">
                    <span class="sec-subtitle" *ngIf="s.Eyebrow">{{ s.Eyebrow }}</span>
                    <h2 class="sec-title">{{ s.Title }}</h2>
                </div>
                <p class="about-text" *ngFor="let p of paragraphs(s.Description)">{{ p }}</p>
            </div>
        </div>
    </div>
</section>


<!---7 Faqs start----->

<section class="faq-section bg-blue">
    <div class="container">
        <div class="row align-items-center g-5">

            <!-- Right Side - FAQ -->
            <div class="col-lg-7">
                <div class="mb-3">
                    <span class="text-danger fw-semibold">FAQs</span>
                    <h2 class="faq-heading">Frequently Asked Questions</h2>
                    <p class="text-muted fs-5">Everything you want to know about IV Drip Therapy</p>
                </div>

                <!-- <div class="accordion" id="faqAccordion">

                    <div class="accordion-item border-0 mb-3">
                        <h2 class="accordion-header">
                            <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                data-bs-target="#q1" aria-expanded="true">
                                <span class="faq-number">01</span> What exactly is IV wellness therapy?
                            </button>
                        </h2>
                        <div id="q1" class="accordion-collapse collapse show" data-bs-parent="#faqAccordion">
                            <div class="accordion-body">
                                It is a procedure where a customised blend of fluids, vitamins, minerals, and
                                antioxidants is infused directly into a vein. In a medical context, this is a controlled
                                and precise method to deliver nutrients that might otherwise be poorly absorbed when
                                taken orally. It is distinct from hospital-based IVs for critical conditions and is
                                instead focused on optimising the health of generally well individuals.
                            </div>
                        </div>
                    </div>

                    <div class="accordion-item border-0 mb-3">
                        <h2 class="accordion-header">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                data-bs-target="#q2">
                                <span class="faq-number">02</span> Why is it considered more effective than taking
                                pills?
                            </button>
                        </h2>
                        <div id="q2" class="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                            <div class="accordion-body">
                                The primary advantage is bioavailability. When you swallow a vitamin pill, it must pass
                                through your stomach and intestines. Factors like your age, gut health, and even what
                                you've recently eaten can limit how much of the nutrient your body actually
                                absorbs—sometimes as little as 10-20%. IV therapy bypasses the digestive system
                                entirely, ensuring 100% of the nutrients enter your bloodstream and are immediately
                                available for your cells to use. This allows for higher, more therapeutic doses to be
                                administered safely and effectively.
                            </div>
                        </div>
                    </div>

                    <div class="accordion-item border-0 mb-3">
                        <h2 class="accordion-header">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                data-bs-target="#q3">
                                <span class="faq-number">03</span> What are the proven benefits of IV therapy when done
                                by a doctor?
                            </button>
                        </h2>
                        <div id="q3" class="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                            <div class="accordion-body">
                                <p>While large-scale clinical trials on every wellness "cocktail" are still emerging,
                                    the foundational science is sound. Qualified doctors use IV therapy to:</p>
                                <h4>Correct Nutrient Deficiencies Rapidly</h4>
                                <p>For individuals with diagnosed deficiencies in vitamins, such as B12, or minerals,
                                    like magnesium, IV administration is a clinically accepted method for rapid
                                    restoration.</p>
                                <h4>Provide Potent Hydration</h4>
                                <p>IV fluids are the fastest way to combat dehydration, which can cause fatigue,
                                    headaches, and brain fog.</p>
                                <h4>Deliver High-Dose Antioxidants </h4>
                                <p>Substances like Vitamin C and Glutathione can be delivered in concentrations that are
                                    impossible to achieve orally. These antioxidants are vital for neutralising free
                                    radicals, reducing inflammation, and supporting cellular repair.</p>
                                <h4>Support Specific Conditions</h4>
                                <p>There is growing evidence for its use in managing symptoms associated with migraines,
                                    chronic fatigue syndrome, and fibromyalgia, by delivering targeted nutrients such as
                                    magnesium and B vitamins.</p>

                            </div>
                        </div>
                    </div>

                    <div class="accordion-item border-0">
                        <h2 class="accordion-header">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                data-bs-target="#q4">
                                <span class="faq-number">04</span> Are there risks involved?
                            </button>
                        </h2>
                        <div id="q4" class="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                            <div class="accordion-body">
                                <p>Yes, which is why medical supervision is crucial. A qualified doctor ensures:</p>
                                <h4>Proper Screening</h4>
                                <p>Patients with certain conditions, such as congestive heart failure or kidney disease,
                                    may not be able to tolerate large fluid volumes or high concentrations of specific
                                    electrolytes. A doctor will conduct a thorough review of your medical history.</p>
                                <h4>Sterile Procedure</h4>
                                <p>The risk of infection, vein irritation (phlebitis), or bruising is minimised by
                                    adhering to strict medical hygiene protocols.</p>
                                <h4>Appropriate Formulation</h4>
                                <p>A doctor ensures the ingredients and dosages are safe and tailored to your specific
                                    health profile, preventing potential toxicity from excessive vitamin intake.</p>
                                <p>In conclusion, when performed by a qualified healthcare professional, IV therapy is a
                                    legitimate and effective tool for enhancing overall wellness. It offers a clear
                                    advantage in nutrient delivery that oral supplements cannot match, providing a
                                    direct route to cellular health.</p>
                            </div>
                        </div>
                    </div>

                </div> -->


                <div class="accordion" id="faqAccordion">

                    <!-- Loading -->
                    <div *ngIf="faqLoading" class="text-center py-4">
                        <div class="spinner-border text-danger" role="status"><span
                                class="visually-hidden">Loading...</span></div>
                        <p class="mt-2 text-muted">Loading questions...</p>
                    </div>

                    <!-- Friendly error with retry -->
                    <div *ngIf="!faqLoading && faqError" class="text-center py-4">
                        <p class="text-muted mb-3">{{ faqError }}</p>
                        <button type="button" class="btn btn-outline-danger btn-sm" (click)="loadFaqs()">Try
                            again</button>
                    </div>

                    <!-- Nothing to show -->
                    <p *ngIf="!faqLoading && !faqError && faqs.length === 0" class="text-muted">
                        Questions will be available here soon.
                    </p>

                    <!-- Questions -->
                    <div class="accordion-item border-0 mb-3" *ngFor="let f of faqs; let i = index">
                        <h2 class="accordion-header">
                            <button class="accordion-button" [class.collapsed]="i !== 0" type="button"
                                data-bs-toggle="collapse" [attr.data-bs-target]="'#faq-' + f.FAQID"
                                [attr.aria-expanded]="i === 0">
                                <span class="faq-number">{{ pad(i + 1) }}</span> {{ f.Question }}
                            </button>
                        </h2>
                        <div [id]="'faq-' + f.FAQID" class="accordion-collapse collapse" [class.show]="i === 0"
                            data-bs-parent="#faqAccordion">
                            <!-- <div class="accordion-body" [innerHTML]="f.Answer"></div> -->
                             <div class="accordion-body faq-answer" [innerHTML]="f.Answer"></div>
                        </div>
                    </div>

                </div>

            </div>


            <!-- Left Side - Single Image -->
            <div class="col-lg-5">
                <img src="/assets/images/hoh/faqs.jpg" alt="IV Therapy Session" class="faq-image img-fluid w-100">
            </div>


        </div>
    </div>
</section>

<!---Faqs end----->